import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Timer } from "lucide-react";
import { api } from "@/lib/api";

const countdown = (d) => (d == null ? "" : d === 0 ? "Ends today" : d === 1 ? "Ends tomorrow" : `Ends in ${d} days`);

export default function PromoBar() {
  const [promo, setPromo] = useState(null);
  useEffect(() => { api.get("/promo").then((r) => setPromo(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    document.documentElement.style.setProperty("--promo-h", promo?.enabled && promo.text ? "36px" : "0px");
    return () => document.documentElement.style.setProperty("--promo-h", "0px");
  }, [promo]);
  if (!promo?.enabled || !promo.text) return null;
  const ends = countdown(promo.days_left);
  const items = Array.from({ length: 4 }, (_, i) => (
    <span key={i} className="inline-flex items-center gap-2 px-6 whitespace-nowrap">
      <Zap size={12} className="text-gold fill-gold" /> {promo.text}
      {ends && <span className="inline-flex items-center gap-1 bg-white/20 rounded-full px-2.5 py-0.5 ml-1" data-testid="promo-bar-countdown"><Timer size={11} /> {ends}</span>}
    </span>
  ));
  const inner = (
    <div className="flex animate-marquee" style={{ animationDuration: "45s" }} data-testid="promo-bar-track">{items}{items}</div>
  );
  return (
    <div className="fixed top-0 inset-x-0 z-[60] h-9 bg-terra text-white text-xs font-semibold tracking-wide overflow-hidden flex items-center" data-testid="promo-bar" role="region" aria-label="Flash offer">
      {promo.link ? <Link to={promo.link} className="block w-full hover:text-gold transition-colors" data-testid="promo-bar-link">{inner}</Link> : inner}
    </div>
  );
}
